<template>
  <object id="htmlHolder" :data="mediaPath" ></object>
</template>

<script>
// import axios from 'axios'
export default {
  name: 'htmlViewer',
  props: ['path'],
  data () {
    return {
      mediaPath: this.path,
      media: '',
      htmlHolder: ''
    }
  },
  mounted () {
    // console.log('html viewer path:' + this.mediaPath)
  },
  watch: {
    path: function (newValue, oldValue) {
      // console.log('html:newpath:' + newValue + 'oldapth:' + oldValue)
      this.mediaPath = newValue
      this.htmlHolder = document.getElementById('htmlHolder')
      // this.clone = this.htmlHolder.cloneNode(true)
      // this.clone.setAttribute('src', newValue)
      // this.htmlHolder.parentNode.replaceChild(this.clone, this.htmlHolder)
      var innerHTMLObj = '<object  :data="' + newValue + '" ></object>'
      this.htmlHolder.innerHTML = ''
      this.htmlHolder.innerHTML = innerHTMLObj
    }
  },
  created () {
    this.$parent.$on('notifyHTMLViewer', this.notifyHTMLViewer)
  },
  beforeDestroy () {
    // console.log('html destroy called')
    if (this.$store.getters.getIsPurchase(this.$store.getters.getcurrentPlayingContent.contentId)) {
      if (this.$store.getters.getIsplaylist) {
        this.$store.dispatch('updatePlayListLastItemViewedByPlaylistId', {'plId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0})
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'playListId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
      } else {
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/contentViewer/contentHelper/htmlViewer.vue?0b2fdd2d